var es = require('elasticsearch');
let index = '';
let type = '';
let AWS = require('aws-sdk');
let AccessKeyId = 'QUtJQTJDQVROSlkyTlU0RFozNDY=';
let SecretAccessKey = "Vnk2QnB5TkxUVllwUmpINUpCSU5GdUtIVC9mQnRSV0RzMVB1N0dHMA==";

let key = atob(AccessKeyId);
let secret = atob(SecretAccessKey)
AWS.config.update({
    credentials: new AWS.Credentials(key, secret),
    region: 'ap-northeast-2'
});

import {searchElaUrl} from "@/api/config";

const limitCount = 10000;
var client = new es.Client({
    host: searchElaUrl,
    connectionClass: require('http-aws-es'),
    httpOptions: {}
});
function init(myIndex, myType) {
    index = myIndex;
    type = myType;
}
function getTotal(body={}) {
    return client.count({
        index: index,
        body: body
    }).then(resp => {
        return resp;
    }, err => {
        return {count: 0,};
    })
}
function search(body = {}) {
    return client.search({
        index: index,
        type: type,
        body: body
    }).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });
};
function newScroll(body, size) {
    let scrollParams = {
        index: index,
        type: type,
        scroll: '10s',
        size: size,
        body: body,
    }
    return client.search(scrollParams).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });
}
function scroll(body, size) {
    let scrollParams = {
        index: index,
        type: type,
        scroll: '10s',
        size: size,
        body: body,
    }
    let getFunc = 'search';
    if(body._scroll_id) {
        scrollParams = {
            scrollId: body._scroll_id,
            scroll: "10s",
        };
        getFunc = 'scroll'
    }
    return client[getFunc](scrollParams).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });
}
function clearScrollId(scrollId) {
    let body = {
        scroll_id: scrollId,
    }
    client.clearScroll({body: body}).then(function (resp) {
        return resp;
    }, function (err) {
        console.log(err);
        return false;
    })
}
export {search, getTotal, init, scroll, clearScrollId, newScroll, limitCount}
